import { ConceptElement } from '../../slateTypes';

function conceptSerializer(conceptElement: ConceptElement) {
  const { type, label } = conceptElement;
  return `{{#${type}}}${encodeURIComponent(label)}{{/${type}}}`;
}

export default conceptSerializer;
